export default "__VITE_ASSET__CUNFroIa__"